import React from "react"
import { faGuitar, faTableTennis, faChessKnight, faGamepad } from "@fortawesome/free-solid-svg-icons"

import SectionContainer from "../components/SectionContainer"
import ActivityTag from "../components/ActivityTag"

const GuitarTag = () => {
  return (
    <ActivityTag
      name="Guitar"
      icon={faGuitar}
      iconcolor="var(--queen-blue)"
    />
  )
}

const PingPongTag = () => {
  return (
    <ActivityTag
      name="Ping Pong"
      icon={faTableTennis}
      iconcolor="var(--orange-engineering)"
    />
  )
}

const ChessTag = () => {
  return (
    <ActivityTag
      name="Chess"
      icon={faChessKnight}
      iconcolor="var(--liver)"
    />
  )
}

const GamesTag = () => {
  return (
    <ActivityTag
      name="Action/Adventure Games"
      icon={faGamepad}
      iconcolor="var(--spanish-green)"
    />
  )
}

// Full section
const ActivitiesSection = () => (
  <SectionContainer header="Activities I enjoy">
    <GuitarTag/>
    <PingPongTag />
    <ChessTag />
    <GamesTag />
  </SectionContainer>
)

export default ActivitiesSection
